import { DynamicText as DynamicTextType } from '../../../../../../types/Survey/Element'
import { DynamicText as DynamicTextAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Modal from '../../../../../UI/Modal/Modal'
import Button from '../../../../../UI/Button/Button'
import props from '../../../../../../redux/props'
import { useSelector } from 'react-redux'
import { useState } from 'react'

const DynamicText: React.FC<Props<DynamicTextType, DynamicTextAnswerType>> = ({ element, answerElement }) => {
  const [show, setShow] = useState(false)
  const toggle = () => setShow(!show)
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div>
      <Core element={element} />
      <Button small className="mt-3 ml-auto" text={t.survey.analysis.averageValues.sliderDropdownGroup.showDetail} onClick={toggle} />
      <Modal large noForm show={show} onClose={toggle} title={element.title}>
        <div className="max-h-60 overflow-x-hidden overflow-y-auto">
          {answerElement.textAnswers.map((a, i) => (
            <div className="flex gap-1">
              <div>{`${i + 1}. `}</div>
              <div>{a.value}</div>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  )
}

export default DynamicText
